import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import leftArrow from "../../assets/images/left-arrow.png";
import rightArrow from "../../assets/images/right-arrow.png";

// Conteneur global
const Main = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-top: 2vw;
`;

const SliderWrapper = styled.div`
    overflow: hidden;
    width: 90%;
`;

const SliderTrack = styled.div<{ $offset: number; $visibleCount: number }>`
    display: flex;
    transition: transform 0.5s ease;
    transform: translateX(${({ $offset, $visibleCount }) => `-${$offset * (100 / $visibleCount)}%`});
`;

const ContainerProjectItem = styled.div`
    flex: 0 0 calc(100% / 3); // Valeur par défaut

    display: flex;
    justify-content: center;

    @media (max-width: 1150px) {
      flex: 0 0 calc(100% / 2);
    }

    @media (max-width: 768px) {
      flex: 0 0 100%;
    }
`;

const ProjectItem = styled.div`
    box-sizing: border-box;
    text-align: center;
    border: solid 7px black;
    border-radius: 20px;
    width: 270px;

    @media (max-width: 768px) {
        width: 210px;
        height: fit-content;
    }
`;

const ProjectImage = styled.img`
    width: 240px;
    height: 200px;
    display: block;
    margin: 10px auto;
    object-fit: contain;
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.05);
    }

    @media (max-width: 768px) {
        width: 180px;
        height: 130px;
    }
`;

const Texte = styled.p`
  font-family: "Archivo", sans-serif;
  font-size: 20px;
  margin: 0;
  border-top: solid 5px black;
  padding: 10px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ArrowContainer = styled.div`
    cursor: pointer;
    width: 50px;

    @media (max-width: 768px) {
        width: 35px;
    }
`;

const ImgArrow = styled.img`
    width: 100%;
`;

const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
`;

function ProjectList({ projects }) {
  const [offset, setOffset] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);

  const totalProjects = projects.length;

  useEffect(() => {
    const updateVisibleCount = () => {
      if (window.innerWidth <= 768) {
        setVisibleCount(1);
      } else if (window.innerWidth <= 1150) {
        setVisibleCount(2);
      } else {
        setVisibleCount(3);
      }
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  const maxOffset = Math.max(0, totalProjects - visibleCount);

  const handleNext = () => {
    setOffset((prev) => (prev < maxOffset ? prev + 1 : 0));
  };

  const handlePrev = () => {
    setOffset((prev) => (prev > 0 ? prev - 1 : maxOffset));
  };

  return (
    <Main>
      <ArrowContainer onClick={handlePrev}>
        <ImgArrow src={leftArrow} alt="fleche de gauche" />
      </ArrowContainer>

      <SliderWrapper>
        <SliderTrack $offset={offset} $visibleCount={visibleCount}>
          {projects.map((project, index) => (
            <ContainerProjectItem key={index}>
              <ProjectItem>
                {project.slug ? (
                  <StyledLink to={`/projet/${project.slug}`}>
                    <ProjectImage src={project.image} alt={project.texte} />
                  </StyledLink>
                ) : (
                  <ProjectImage
                    src={project.image}
                    alt={project.texte}
                    style={{ cursor: "default" }}
                  />
                )}
                <Texte>{project.texte}</Texte>
              </ProjectItem>
            </ContainerProjectItem>
          ))}
        </SliderTrack>
      </SliderWrapper>

      <ArrowContainer onClick={handleNext}>
        <ImgArrow src={rightArrow} alt="fleche de droite" />
      </ArrowContainer>
    </Main>
  );
}

export default ProjectList;
